// extracted by mini-css-extract-plugin
export default {"buttonKey":"Hotkey_buttonKey__-wWu7","small":"Hotkey_small__AzjNh","dull":"Hotkey_dull__v9N3w"};